// src/sot/primitives/TopBarProfile.jsx
import React from "react";
import "@/styles/afrimed.css";
import "@/sot/afrimed-design-system.css";

// ---------------------------------------------------------------------------
// Icon asset paths
// ---------------------------------------------------------------------------
const ICON_ATTACH    = "/icons/doctor/attach-file.svg";
const ICON_CALENDAR  = "/icons/doctor/event-calendar-button.svg";
const ICON_SETTINGS_PUBLIC = "/icons/settings.svg";
const ICON_SETTINGS  = "/icons/doctor/settings_cog_patient.svg";

// ---------------------------------------------------------------------------
// Reusable icon button (40 × 40 outer, 20 × 20 glyph)
// ---------------------------------------------------------------------------
function TopBarIconButton({ icon, alt, onClick, children }) {
  if (typeof onClick !== "function") return null;
  return (
    <button
      onClick={onClick}
      type="button"
      className="inline-flex items-center justify-center h-10 w-10 rounded-[12px] backdrop-blur"
      style={{
        background: "rgb(var(--clr-surface-cont-highest))",
        boxShadow: "0 8px 18px rgba(15,23,42,0.18)",
      }}
    >
      {children ? (
        children
      ) : (
        <img
          src={icon}
          alt={alt}
          className="h-5 w-5 object-contain"
          draggable="false"
        />
      )}
    </button>
  );
}

// ---------------------------------------------------------------------------
// TopBarProfile (doctor & patient)
// - No internal horizontal padding → parent controls 720px rails
// - Height is natural; parent controls vertical placement over cover
// ---------------------------------------------------------------------------
export default function TopBarProfile({
  variant = "doctor",
  onBack,
  onAttach,
  onCalendar,
  onRightAction,
  className = "",
}) {
  const rightIcon = variant === "patient" ? ICON_SETTINGS : ICON_SETTINGS_PUBLIC;
  const rightAlt  = "Settings";

  return (
    <div
      className={`
        w-full
        flex items-center justify-between
        pointer-events-auto
        ${className}
      `}
    >
      {/* Left side: Back button */}
      <TopBarIconButton alt="Back" onClick={onBack}>
        <svg
          viewBox="0 0 20 20"
          aria-hidden="true"
          className="h-5 w-5"
          style={{ color: "rgb(var(--afrimed-overlay-icon))" }}
        >
          <path
            d="M12.5 4.5L7 10l5.5 5.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </TopBarIconButton>

      {/* Right side buttons */}
      <div className="flex items-center gap-3">
        <TopBarIconButton
          icon={ICON_ATTACH}
          alt="Attach file"
          onClick={onAttach}
        />
        <TopBarIconButton
          icon={ICON_CALENDAR}
          alt="Calendar"
          onClick={onCalendar}
        />
        <TopBarIconButton
          icon={rightIcon}
          alt={rightAlt}
          onClick={onRightAction}
        />
      </div>
    </div>
  );
}
